module.exports = __webpack_public_path__ + "c849d57e9bcdcd4af52ad8220da7f68a.png";